<div *ngIf="show" class="spinner spinner-{{color}}">
    <div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div>
    <span>{{ message }}</span>
</div>